var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SmartLayoutC,{key:"page_container",attrs:{"compId":"page_container","mode":_setup.layoutMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }